import './floating_button.css';

const FloatingReserve = () => {
  return (
    <div className="floating-container">
      <a 
        href="https://regina.foodeo.es/reserva"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-reserve"
      >
        🍕 Reserve in Malaga
      </a>
      
      <a 
        href="tel:+34956790220" /* <-- Virgolletta corretta qui */
        target="_blank"
        rel="noopener noreferrer"
        className="floating-reserve"
      >
        🍕 Reserve in Sotogrande
      </a>
    </div>
  );
};

export default FloatingReserve;
